/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { HpeTopViewUsage, HpeTopViewUsageRecord } from '../../../resources/hpe-details.model';
import { HpeTopUsageGridDefinition } from './hpe-top-usage-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-hpe-top-usage-dialog',
  templateUrl: 'hpe-top-usage-dialog.component.html',
  styleUrls: ['hpe-top-usage-dialog.component.scss'],
  providers: [HpeTopUsageGridDefinition],
})
export class HpeTopUsageDialogComponent implements DialogInput<HpeTopViewUsage> {
  input: HpeTopViewUsage;

  constructor(private dialogRef: MatDialogRef<any>,
              public gridDefinition: HpeTopUsageGridDefinition) {

  }

  onGoToRecord(record: HpeTopViewUsageRecord): void {
    this.dialogRef.close(record);
  }
}

export const hpeTopViewUsageDialogRoute = createDialogRoute({
  component: HpeTopUsageDialogComponent,
});
